import { useContext, useCallback, useState } from 'react';
import { AppFabricContext } from './ContextProvider';

// usePerformance will hold functions to mark site speed metrics using AF profiler
const usePerformance = () => {
  const { instance, profiler, setProfiler } = useContext(AppFabricContext);
  const [markedMeasure, setMarkedMeasure] = useState();

  //  modifyProfilerEndTime changes the profiler object's endTime to when the page loaded (stored in markedMeasure state)
  const modifyProfilerEndTime = useCallback(
    (currentTimestamp) => {
      const timeElapsed = Math.round(
        currentTimestamp - markedMeasure.timestamp,
      );
      if (profiler._mainSpan) {
        profiler._mainSpan.endTime -= timeElapsed;
      }
    },
    [profiler, markedMeasure],
  );

  // sets the profiler to null so that no subsequent page load timings will be recorded.
  const cancelProfiler = useCallback(() => {
    setProfiler(null);
    setMarkedMeasure(null);
  }, [setProfiler]);

  // endMarkedMeasure will look for a profiler and end any marked measure being tracked
  const endMarkedMeasure = useCallback(() => {
    // if our page loads and endMarkedMeasure is called before the AF instance is mounted, store timestamp and path of page load in state
    if (!profiler && !markedMeasure) {
      setMarkedMeasure({
        timestamp: performance.now(),
        pathname: window.location.pathname,
      });
    }

    if (profiler && instance?.performance) {
      // ensure we are endingMarkedMeasure on same page that profiler started on. profiler._profileName is the route the profiler started
      const pathname = markedMeasure?.pathname || window.location.pathname;
      if (profiler._profileName === pathname) {
        profiler.end();
        // if our page loaded before endMarkedMeasure was called, change the profiler's endTime to be when the page was loaded
        if (markedMeasure) {
          modifyProfilerEndTime(performance.now());
        }
        instance.performance.record(profiler);
      }
      cancelProfiler();
    }
  }, [
    profiler,
    markedMeasure,
    instance,
    cancelProfiler,
    modifyProfilerEndTime,
  ]);

  return { endMarkedMeasure, cancelProfiler };
};

export default usePerformance;
